module.exports = __webpack_public_path__ + "static/media/minus.d78e2fa7.svg";